import React from "react";

import { AppLayout } from "@src/components/app_layout";
import { ErrorBoundary } from "@src/components/error_boundary";
import { ROUTES } from "@src/constants";
import useFeatureToggle from "@src/hooks/use_feature_toggle";
import { AdminProjectAssignmentsPage } from "@src/pages/admin/admin_project_assignments_page";
import { AdminRoleAssignmentPage } from "@src/pages/admin/admin_role_assignment_page";
import { EmployeeDataPage } from "@src/pages/admin/employee_data_page";
import { ImportResourcePlanPage } from "@src/pages/admin/import_resource_plan_page";
import { RegionAssignmentPage } from "@src/pages/admin/region_assignment_page";
import { RoleAssignmentPage } from "@src/pages/admin/role_assignment_page";
import { SapCsvUploadPage } from "@src/pages/admin/sap_csv_upload_page";
import { CreateProjectPage } from "@src/pages/create_project_page";
import { DashBoardPage } from "@src/pages/dashboard";
import { ProjectPage } from "@src/pages/project_page";
import { ProjectPageV2 } from "@src/pages/project_page_v2";
import { ProjectsOverviewPage } from "@src/pages/projects_overview_page";
import { StaffingRequestOverviewPage } from "@src/pages/staffing_requests_overview_page";
import { StartScreenPage } from "@src/pages/start_screen_page";
import { TeamLeadSuggestTeamMemberPage } from "@src/pages/team_lead_suggest_team_member_page";
import { TeamMemberOverviewPage } from "@src/pages/team_member_overview_page";
import {
  Navigate,
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import { ResourcePlanOverviewPage } from "@src/pages/resource_plan_overview_page";

const Router: React.FC = () => {
  const isPLMergedTableEnabled: boolean = useFeatureToggle("plRedesign");

  const router = createBrowserRouter([
    {
      path: "/",
      element: <AppLayout />,
      errorElement: <ErrorBoundary />,
      children: [
        {
          path: `${ROUTES.PROJECT_LEAD.RESOURCE_PLAN}`,
          element: <ResourcePlanOverviewPage />,
        },
        {
          path: `${ROUTES.PROJECT_LEAD.PROJECTS_CREATE}/:id?`,
          element: <CreateProjectPage />,
        },
        {
          path: `${ROUTES.PROJECT_LEAD.PROJECTS}/:id`,
          element: isPLMergedTableEnabled ? <ProjectPageV2 /> : <ProjectPage />,
        },
        {
          path: ROUTES.PROJECT_LEAD.PROJECTS,
          element: <ProjectsOverviewPage />,
        },
        {
          path: ROUTES.ADMIN.REGION_ASSIGNMENT,
          element: <RegionAssignmentPage />,
        },
        {
          path: ROUTES.MANAGER.DASHBOARD,
          element: <DashBoardPage />,
        },
        {
          path: ROUTES.ADMIN.ROLE_ASSIGNMENT_V2,
          element: <RoleAssignmentPage />,
        },
        {
          path: ROUTES.ADMIN.ROLE_ASSIGNMENT,
          element: <AdminRoleAssignmentPage />,
        },
        {
          path: ROUTES.ADMIN.PROJECT_ASSIGNMENTS_IMPORT,
          element: <ImportResourcePlanPage />,
        },
        {
          path: ROUTES.ADMIN.PROJECT_ASSIGNMENTS,
          element: <AdminProjectAssignmentsPage />,
        },
        {
          path: ROUTES.ADMIN.EMPLOYEE_DATA,
          element: <EmployeeDataPage />,
        },
        {
          path: ROUTES.ADMIN.SAP,
          element: <SapCsvUploadPage />,
        },
        {
          path: `${ROUTES.TEAM_LEAD.STAFFING_REQUESTS_DETAILS}/:id`,
          element: <TeamLeadSuggestTeamMemberPage />,
        },
        {
          path: ROUTES.TEAM_LEAD.STAFFING_REQUESTS,
          element: <StaffingRequestOverviewPage />,
        },
        {
          path: ROUTES.TEAM_LEAD.TEAM_OVERVIEW,
          element: <TeamMemberOverviewPage />,
        },
        {
          path: "/",
          element: <StartScreenPage />,
        },
        {
          path: "*",
          element: <Navigate to="/" replace />,
        },
      ],
    },
  ]);

  return <RouterProvider router={router} />;
};

export default Router;
